function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "RefundDraw",
  transform: "translate(406.108 -40.172)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_224",
  "data-name": "Caminho 224",
  d: "M-406.055,65.746s34.488,3.73,65.5,34.737S-248.03,148.716-187,110.326-37.38,82.764-37.38,82.764",
  fill: "none",
  stroke: "#f6f6f6",
  strokeWidth: 1,
  strokeDasharray: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_189",
  "data-name": "Caminho 189",
  d: "M396.818,318.329l-16.617,3.4-.379-.036-14.6-1.474V301.712L383.1,298.69l12.967,1.512,0,.082v.039Z",
  transform: "matrix(0.616, -0.788, 0.788, 0.616, -630.134, 232.555)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_190",
  "data-name": "Caminho 190",
  d: "M442.756,323.345l-16.617,3.4-.379-.036V307.736l16.245-2.436Z",
  transform: "matrix(0.616, -0.788, 0.788, 0.616, -662.368, 265.666)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_213",
  "data-name": "Caminho 213",
  d: "M341.818,168.329l-16.617,3.4-.379-.039-14.6-1.474V151.712L328.1,148.69l12.967,1.512,0,.082v.039Z",
  transform: "translate(-500.397 -175.636) rotate(19)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_214",
  "data-name": "Caminho 214",
  d: "M387.756,173.345l-16.617,3.4-.379-.039V157.736l16.245-2.436Z",
  transform: "translate(-542.199 -195.334) rotate(19)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_216",
  "data-name": "Caminho 216",
  d: "M68.209,42.393,32.338,49.73l-.815-.082L0,46.469V6.522L38.588,0l27.99,3.261.008.177,0,.087Z",
  transform: "translate(-402.863 65.724) rotate(-22)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_223",
  "data-name": "Caminho 223",
  d: "M14.25,8.856,6.756,10.389l-.17-.017L0,9.708V1.362L8.061,0l5.847.681,0,.037V.736Z",
  transform: "matrix(0.899, -0.438, 0.438, 0.899, -178.592, 66.665)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_217",
  "data-name": "Caminho 217",
  d: "M36.686,38.955.815,46.292,0,46.211V5.258L35.064,0Z",
  transform: "translate(-372.348 57.102) rotate(-22)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_222",
  "data-name": "Caminho 222",
  d: "M7.664,8.138.17,9.671,0,9.654V1.1L7.325,0Z",
  transform: "matrix(0.899, -0.438, 0.438, 0.899, -172.358, 64.424)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_218",
  "data-name": "Caminho 218",
  d: "M460.818,470.329l-16.617,3.4-.379-.039-14.6-1.474V453.712L447.1,450.69l12.967,1.512,0,.082v.039Z",
  transform: "translate(-218.962 -544.938) rotate(30)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_219",
  "data-name": "Caminho 219",
  d: "M506.756,475.345l-16.617,3.4-.379-.039V459.736l16.245-2.436Z",
  transform: "translate(-256.237 -572.25) rotate(30)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_220",
  "data-name": "Caminho 220",
  d: "M246.961,377.869l-6.7,1.371-.152-.015-5.888-.594v-7.462l7.208-1.218,5.228.609,0,.033v.016Z",
  transform: "matrix(0.695, 0.719, -0.719, 0.695, -168.422, -303.116)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_221",
  "data-name": "Caminho 221",
  d: "M357.073,389.877l-6.7,1.371-.152-.015v-7.65l6.55-.982Z",
  transform: "matrix(0.695, 0.719, -0.719, 0.695, -236.274, -390.665)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_9",
  "data-name": "Elipse 9",
  cx: 1.878,
  cy: 1.878,
  r: 1.878,
  transform: "translate(-96.392 98.023)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_21",
  "data-name": "Elipse 21",
  cx: 1.878,
  cy: 1.878,
  r: 1.878,
  transform: "translate(-188.392 128.75)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_20",
  "data-name": "Elipse 20",
  cx: 1.923,
  cy: 1.923,
  r: 1.923,
  transform: "translate(-298.437 87.729)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_105",
  "data-name": "Caminho 105",
  d: "M389.772,68.98h-1.979V67h-.386v1.98h-1.981v.387h1.981v1.98h.386v-1.98h1.979Z",
  transform: "matrix(0.875, 0.485, -0.485, 0.875, -649.4, -120.763)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_225",
  "data-name": "Caminho 225",
  d: "M389.772,68.98h-1.979V67h-.386v1.98h-1.981v.387h1.981v1.98h.386v-1.98h1.979Z",
  transform: "matrix(0.875, 0.485, -0.485, 0.875, -421.812, -190.302)",
  fill: "#f6f6f6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_10",
  "data-name": "Elipse 10",
  cx: 1.073,
  cy: 1.073,
  r: 1.073,
  transform: "translate(-200.827 64.943)",
  fill: "#ff6584"
}));

var SvgRefundDraw = function SvgRefundDraw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368.789,
    height: 102.66,
    viewBox: "0 0 368.789 102.66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefundDraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RefundDraw.d2c147b2.svg";
export { ForwardRef as ReactComponent };